// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import React from 'react';
import { Grid, Typography, Box, Breadcrumbs, Link, Theme } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { IconMathGreater } from '@tabler/icons-react';

interface BreadCrumbType {
  subtitle?: string;
  items?: any[];
  title?: string;
}

const Breadcrumb = ({ subtitle, items, title }: BreadCrumbType) => (
  <Grid
    container
    sx={{
      backgroundColor: 'transparent',
      borderRadius: (theme: Theme) => (typeof theme.shape.borderRadius === 'number' ? theme.shape.borderRadius / 4 : 4),
      opacity: { xs: 0.7, md: 'unset' },
      height: 'fit-content',
      minHeight: 'fit-content',
      m: 0,
      p: 0,
      '& .MuiTypography-root': {
        fontSize: { xs: '12px', md: '14px' },
      },
    }}
  >
    <Grid
      sx={{ m: 0, p: 0 }}
      size={{
        xs: 12,
        sm: 12,
        lg: 8
      }}>
      {title && (
        <Typography variant="h4" sx={{ m: 0, p: 0, lineHeight: 1 }}>
          {title}
        </Typography>
      )}
      <Typography color="textSecondary" variant="h6" fontWeight={400} sx={{ m: 0, p: 0, lineHeight: 1 }}>
        {subtitle}
      </Typography>
      <Breadcrumbs
        separator={
          <IconMathGreater size="12" fill="textSecondary" fillOpacity={'0.6'} style={{ margin: '0 5px' }} /> // IconCircle
        }
        sx={{
          alignItems: 'center',
          mt: items ? '4px' : '0',
          m: 0,
          p: 0,
          minHeight: 'auto',
          '& .MuiBreadcrumbs-ol': {
            m: 0,
            p: 0,
          },
        }}
        aria-label="breadcrumb"
      >
        {items
          ? items.map((item) => (
              <div key={item.title}>
                {item.to ? (
                  <Link underline="none" color="inherit" component={NavLink} to={item.to}>
                    {item.title}
                  </Link>
                ) : (
                  <Typography color="textPrimary">{item.title}</Typography>
                )}
              </div>
            ))
          : ''}
      </Breadcrumbs>
    </Grid>
  </Grid>
);

export default Breadcrumb;
